import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  HStack,
  Icon,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  VStack,
} from '@chakra-ui/react';
import { HiAdjustmentsHorizontal } from 'react-icons/hi2';

import { useUiComponentsInternationalContext } from '@repo/static-translations';

export default function FilterTags({
  activeFilters,
  clearFilters,
  handleFilterTag,
}) {
  const { tt } = useUiComponentsInternationalContext();

  if (!activeFilters.length) return null;

  return (
    <VStack mb="6" w="full">
      <Flex align="center" justify="space-between" w="full">
        <Text
          textStyle="body"
          fontWeight="bold"
          display="flex"
          alignItems="center"
        >
          <Icon as={HiAdjustmentsHorizontal} w="6" h="6" mr="2" />
          {tt(s => s.blocksDeptComponents.filtersLabel)}
        </Text>
        <Text
          textStyle="caption"
          textDecor="underline"
          cursor="pointer"
          _hover={{ textDecoration: 'none' }}
          onClick={clearFilters}
          aria-label={tt(s => s.blocksDeptComponents.clearAllFiltersAriaLabel)}
        >
          {tt(s => s.blocksDeptComponents.clearAllLabel)}
        </Text>
      </Flex>
      <HStack spacing={2} wrap="wrap" justifyContent="flex-start" w="full">
        {activeFilters.map(({ filters, group }) => (
          <Fragment key={group}>
            {filters.map(filter =>
              filter?.active ? (
                <Tag
                  size="lg"
                  key={filter.tag}
                  borderRadius="full"
                  variant="outline"
                  backgroundColor="white"
                  color="typography.base"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  aria-label={tt(
                    s => s.blocksDeptComponents.removeFilterAriaLabel,
                    { filter: filter.title }
                  )}
                >
                  <TagLabel
                    sx={{ textWrap: 'nowrap' }}
                    textStyle="caption"
                    pos="relative"
                    top="2px"
                    fontWeight="bold"
                  >
                    {filter.title}
                  </TagLabel>
                  <TagCloseButton
                    onClick={() => handleFilterTag(filter, group)}
                  />
                </Tag>
              ) : null
            )}
          </Fragment>
        ))}
      </HStack>
    </VStack>
  );
}

FilterTags.propTypes = {
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      tag: PropTypes.string,
      active: PropTypes.bool,
    })
  ).isRequired,
  handleFilterTag: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};
